/**
 * Determines whether a given pathname belongs to the Mission Control section.
 *
 * @param {string | null} pathname - The full pathname to check.
 * @returns {boolean} - `true` if the pathname matches a Mission Control route; otherwise, `false`.
 */
export const isMcRoute = (pathname: string | null): boolean => {
  if (!pathname) return false;
  // Homepage (`/`, `/en`, `/en/`) renders Mission Control via rewrite — treat it as an MC route.
  if (/^\/(?:ro|en)?\/?$/.test(pathname)) return true;
  return /^\/(?:[a-z]{2}\/)?mc(\/.*)?$/.test(pathname);
};
